{
  "home": {
    "title": "Learn",
    "for": "For {{name}} · {{age}}",
    "nextFor": "Next for {{name}}",
    "nextForBaby": "Your next lesson",
    "read": "Read",
    "readAgain": "Read again",
    "courses": "Courses",
    "forYouReads": "Reads for parents",
    "now": "Right now",
    "usefulNow": "Useful now"
  },
  "books": {
    "title": "Books",
    "lead": "Five handbooks to keep, print or read offline. One purchase opens all five.",
    "yours": "Yours",
    "soon": "Coming soon",
    "onSale": "Handbook",
    "soonNote": "We are writing this volume.",
    "get": "Get the book",
    "view": "See inside",
    "close": "Close",
    "open": "Open",
    "download": "Download PDF",
    "preparing": "Bought. We are preparing the PDF and will let you know when it is ready to download.",
    "pages": "{{count}} pages · PDF",
    "inside": "Inside",
    "look": "A look inside",
    "pageOf": "{{n}} of {{total}}",
    "zoom": "Tap a page to see it full size.",
    "mine": "All 5 handbooks are yours. Download them any time, even without a subscription.",
    "forever": "One payment opens all 5 handbooks. Yours to keep, even without a subscription.",
    "price": "{{amount}} once",
    "buyOneclick": "Buy with saved card · {{amount}}",
    "buyCard": "Buy · {{amount}}",
    "buying": "One moment…",
    "pending": "Checking your payment. Please don't pay again.",
    "slow": "Your payment is still processing. The books will appear by themselves. If you were charged and nothing changes, write to support@getbabyplan.com.",
    "done": "Done! All 5 handbooks are yours.",
    "error": "The payment didn't go through. Please try again or use another card.",
    "notInApp": "This volume isn't sold in the app yet.",
    "soonBody": "We are writing this volume. It will appear here when it's ready.",
    "items": {
      "first-year": {
        "title": "Your baby's first year", "ages": "Birth to 12 months", "text": "Feeding, sleep, crying and growth, month by month, with printable logs.",
        "about": "Everything for the first twelve months in one calm, picture-first book: what is normal, what to do and when to call the doctor.",
        "inside": ["Newborn care, feeding and safe sleep, step by step", "First foods, growth and milestones by month", "When to call the doctor, plus printable logs and forms"],
        "shots": ["The first year at a glance: feeding, sleep and growth by month", "The first tub bath, step by step with pictures", "Textures, stage by stage: first foods from purees to finger foods", "A printable 24-hour log for feeds, sleep and diapers"]
      },
      "second-year": {
        "title": "The second year", "ages": "12 to 24 months", "text": "First steps, first words, toddler food and naps.",
        "about": "Your toddler from 12 to 24 months: walking, talking, eating and sleeping, with ready words for the hard moments.",
        "inside": ["Food and drinks: goodbye bottle, picky eating", "Sleep, words, feelings and behavior", "Safety, health and a milestone checklist"],
        "shots": ["The second year at a glance", "Picky eating: what is normal and what helps", "Say this instead: calm words for tantrums", "A milestone checklist for 12 and 15 months"]
      },
      "third-year": {
        "title": "The third year", "ages": "2 to 3 years", "text": "Big feelings, potty learning and getting ready for preschool.",
        "about": "From 2 to 3 years: big feelings, potty learning, play and getting ready for preschool, page by page.",
        "inside": ["Development and when to ask about it", "Potty learning, sleep and daily rhythm", "Health, safety and a 30-month checklist"],
        "shots": ["When to ask about development", "A day with a 2-year-old, hour by hour", "Potty learning: one possible first week", "Bums and bath time"]
      },
      "sleep": {
        "title": "Sleep, birth to 3", "ages": "Sleep guide", "text": "Safe sleep, naps, nights and bedtime, stage by stage.",
        "about": "Safe sleep, naps, nights and bedtime from birth to 3, with sample schedules for every stage.",
        "inside": ["Safe sleep and a room that helps", "Naps, nights and bedtime routines", "Sample days for every age"],
        "shots": ["Sleep from birth to 3 at a glance", "Dark, cool and quiet: setting up the room", "A night at 2 months, hour by hour", "3 to 5 months: a rhythm appears"]
      },
      "parents": {
        "title": "For you, the parent", "ages": "Parent guide", "text": "Rest, stress, your body and your partner, with quick calming practices.",
        "about": "A book for you, not the baby: rest, stress, your body, your relationship and where to get help.",
        "inside": ["Quick calming practices for hard moments", "Your body after birth and the first weeks", "Partners, help and who to call"],
        "shots": ["Contents", "Let your shoulders drop: a two-minute practice", "Your first 6 weeks, week by week", "Ready-made messages to ask for help"]
      }
    }
  },
  "draft": "Draft",
  "minutes_one": "{{count}} min",
  "minutes_other": "{{count}} min",
  "minRead_one": "{{count}} min read",
  "minRead_other": "{{count}} min read",

  "nav": {
    "backToLearn": "Back to Learn",
    "backToCourse": "Back to the course",
    "backToPhases": "Back to phases",
    "backToParents": "Back to For you"
  },

  "tip": {
    "title": "Tip for today",
    "ask": "Ask about this",
    "aboutPhase": "About this phase",
    "topic": { "sleep": "Sleep", "feeding": "Feeding", "development": "Growing", "parent": "For you" }
  },

  "phase": {
    "cardLabel": "Your baby's phase",
    "yourBaby": "your baby",
    "nowWeek": "Now · week {{week}} of {{total}}",
    "startsIn": "Coming up · {{when}}",
    "endedAgo_one": "Just ended · {{count}} day ago",
    "endedAgo_other": "Just ended · {{count}} days ago",
    "endedAgo_zero": "Just ended",
    "calmEyebrow": "Right now",
    "signsLabel": "What you may see",
    "nextLabel": "Next:",
    "calmTitle": "A settled stretch",
    "calmText": "No big leap expected for {{name}}. The same steps every evening are all it takes.",
    "settling": "Sleep usually settles back in the next week or two.",
    "next": "Next phase {{when}}:",
    "all": "All phases",
    "statusFor": "{{name}} · {{status}}",
    "forName": "For {{name}}",
    "forYourBaby": "For your baby",
    "sleepLabel": "Sleep",
    "sleepImpact": "Sleep: {{level}}",
    "disclaimer": "Every baby moves at their own pace. These ages are a rough guide, not a deadline. If something worries you, ask your pediatrician."
  },
  "ring": {
    "weeksLeft_one": "week left",
    "weeksLeft_other": "weeks left",
    "daysLeft_one": "day left",
    "daysLeft_other": "days left",
    "weeksToGo_one": "week to go",
    "weeksToGo_other": "weeks to go",
    "daysToGo_one": "day to go",
    "daysToGo_other": "days to go"
  },
  "kind": { "sleep_regression": "Sleep shift", "growth_spurt": "Growth spurt", "development": "New skills" },
  "impact": {
    "low": "Most babies sleep much as before.",
    "medium": "A few bumpier nights are common. They pass.",
    "high": "Nights may be harder for a few weeks. Keeping the same routine helps most."
  },
  "impactShort": { "low": "light touch", "medium": "some change", "high": "noticeable" },
  "when": {
    "days_one": "in {{count}} day",
    "days_other": "in {{count}} days",
    "weeks_one": "in {{count}} week",
    "weeks_other": "in {{count}} weeks",
    "months_one": "in about {{count}} month",
    "months_other": "in about {{count}} months"
  },
  "age": {
    "week": "Week {{n}}",
    "wkShort": "wk",
    "moShort": "mo",
    "weeks": "Weeks {{from}}–{{to}}",
    "aboutMonths": "About {{n}} months",
    "months": "{{from}}–{{to}} months"
  },

  "phases": {
    "title": "Phases",
    "intro": "Babies grow in leaps. Some leaps unsettle sleep for a little while; knowing what is coming makes it easier.",
    "age": "{{name}} is in week {{weeks}}.",
    "ageCorrected": "{{name}} is in week {{weeks}} (corrected age).",
    "now": "Now",
    "soon": "Coming up",
    "recent": "Recently",
    "all": "All phases by age",
    "allLink": "All phases",
    "emptyTitle": "Phases are on their way",
    "emptyText": "We are writing about each stage of the first three years. Check back soon."
  },

  "course": {
    "title": "First 3 years",
    "intro": "Short lessons for every stage, from the first weeks to age 3. A few minutes each.",
    "summary": "Every stage from birth to age 3",
    "stagesLabel": "Stages",
    "lessonsN_one": "{{count}} lesson",
    "lessonsN_other": "{{count}} lessons",
    "all": "All lessons",
    "progress": "{{done}} of {{total}} lessons read",
    "readOf": "{{done}} of {{total}} read",
    "progressLabel": "{{done}} of {{total}} lessons read",
    "mode": { "start": "Start here", "continue": "Continue", "next": "Up next", "done": "Read again" },
    "go": { "start": "Start", "continue": "Continue", "next": "Continue" },
    "doneShort": "All lessons · read again",
    "cta": { "start": "Start the first lesson", "continue": "Continue reading", "next": "Read the next lesson" },
    "chapterN": "Chapter {{n}}",
    "chapterCount": "{{done}}/{{total}}",
    "read": "Read",
    "started": "Started",
    "forAge": "for {{name}}'s age",
    "emptyTitle": "The course is on its way",
    "emptyText": "Lessons will appear here as soon as they are ready.",
    "doneTitle": "You have read the whole course",
    "doneText": "New lessons will show up here. Any lesson is there to read again."
  },

  "reader": {
    "lesson": "Lesson",
    "lessonOf": "Lesson {{n}} of {{total}}",
    "markRead": "Mark as read",
    "markReadNext": "Mark as read · next lesson",
    "marking": "Saving…",
    "markedRead": "Marked as read",
    "isRead": "You have read this lesson",
    "markOffline": "You're offline. Mark it as read when you're back online.",
    "markError": "That did not save. Please try again.",
    "next": "Next lesson",
    "upNext": "Up next",
    "courseProgress": "Where this lesson is in the course",
    "ask": "Ask about this lesson",
    "askPrefill": "About the lesson \"{{title}}\": ",
    "askArticle": "Ask about this",
    "askArticlePrefill": "About \"{{title}}\": ",
    "nextLesson": "Next lesson",
    "endTitle": "That's the whole course for now",
    "endText": "New lessons are on their way.",
    "alsoForYou": "Also for you",
    "opensOutside": "(opens outside the app)"
  },

  "callout": { "tip": "Tip", "note": "Note", "see_doctor": "See a doctor" },

  "parents": {
    "title": "For you",
    "intro": "A minute for yourself. Looking after you is part of looking after your baby.",
    "open": "Open",
    "seeAll": "See all",
    "articlesCount_one": "{{count}} article",
    "articlesCount_other": "{{count}} articles",
    "weekLink": "Your week",
    "checkinLabel": "Daily check-in",
    "articles": "Reads for parents",
    "emptyTitle": "Articles are on their way",
    "emptyText": "Short reads for parents will appear here soon."
  },
  "topic": { "rest": "Rest", "support": "Support", "relationship": "Together", "body": "Body", "feelings": "Feelings", "boundaries": "Boundaries", "care": "Care", "wellbeing": "Wellbeing", "work": "Work" },

  "mood": { "1": "Rough", "2": "Low", "3": "Okay", "4": "Good", "5": "Great" },
  "energy": { "1": "Empty", "2": "Low", "3": "Some", "4": "Good", "5": "Full" },

  "checkin": {
    "question": "How are you today?",
    "todayDone": "Today you feel",
    "oneTap": "One tap is enough. Your partner does not see these answers.",
    "addDetails": "Add details",
    "addDetailsHint": "Add your energy, your own sleep or a note.",
    "edit": "Edit",
    "energyIs": "Energy: {{level}}",
    "sleptIs": "Slept {{n}} h",
    "hasNote": "Note",
    "titleToday": "How are you today?",
    "titleDay": "How were you on {{day}}?",
    "close": "Close",
    "private": "Just for you. Your partner does not see these answers.",
    "mood": "Mood",
    "energy": "Energy",
    "optional": "optional",
    "tapToClear": "Tap the chosen one again to clear it.",
    "sleep": "Your own sleep",
    "sleepLess": "Half an hour less",
    "sleepMore": "Half an hour more",
    "sleepUnset": "Not set",
    "hours": "{{n}} h",
    "clear": "Clear",
    "note": "Note",
    "notePlaceholder": "Anything on your mind?",
    "pickMood": "Pick a mood to save.",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Saved. Thank you for checking in.",
    "queued": "Saved on this phone. It syncs when you're back online.",
    "errorGeneric": "That did not save. Please try again.",
    "errorInvalid": "Something in the form is not right. Please check it.",
    "loadError": "Could not load your check-ins.",
    "support": "Thank you for being honest. Hard days are common with a baby. If you feel low most days, talk to your doctor. You can call or text the National Maternal Mental Health Hotline any time:",
    "hotline": "1-833-852-6262",
    "hotlineTel": "+18338526262"
  },

  "week": {
    "label": "Your last seven days",
    "today": "Today",
    "dayLabel": "{{day}}: {{mood}}",
    "daySleep": ", slept {{n}} hours",
    "dayEmpty": "{{day}}: no check-in. Add one",
    "hoursShort": "{{n}}h",
    "avgMood": "This week mostly {{mood}}",
    "avgSleep": "your sleep about {{n}} h a night",
    "none": "Tap a day to add how it went."
  },

  "state": {
    "loading": "Loading",
    "retry": "Try again",
    "staleOffline": "Offline · showing what this phone saved",
    "staleError": "Could not refresh · showing what this phone saved",
    "offline": { "title": "You're offline", "text": "This page has not been saved on this phone yet. It opens once you're back online." },
    "notFound": { "title": "This page is not here", "text": "It may have moved or is not published yet." },
    "generic": { "title": "Something went wrong", "text": "Please try again in a moment." }
  },

  "moods": {
    "question": "How are you right now?",
    "today": "Today",
    "again": "How are you now?",
    "cancel": "Not now",
    "saved": "Saved. Thank you for checking in.",
    "waiting": "will sync",
    "changeLabel": "Change this answer",
    "delete": "Delete this answer",
    "replyLow": "That sounds hard. One minute of slow breathing can take the edge off.",
    "replyNight": "Nights are the hardest. Here is a short practice for right now.",
    "replyOkay": "Thanks for checking in. You can add another answer any time today.",
    "replyGood": "Glad to hear it. Small good moments count.",
    "tryPractice": "Try it now",
    "detailsHint": "Add how you slept last night and your energy.",
    "detailsAdd": "Add sleep and energy",
    "detailsTitle": "Your sleep and energy"
  },

  "tracks": {
    "title": "Courses",
    "readOf": "{{done}} of {{total}} read",
    "backTo": "Back to {{title}}",
    "practice": "Practice",
    "article": "Article",
    "missingTitle": "This course is not here",
    "missingText": "It may have moved. Go back to Learn to see all courses."
  }
}
